var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovartis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7988 30.661L41.6295 31.1011C44.4562 32.3452 50.812 37.2876 50.812 47.2318C50.812 56.6004 42.9159 66.0368 30.509 66.0368C15.0723 66.0368 9.749 57.0067 9.749 48.7128C9.749 38.0832 17.1796 31.008 17.1796 21.3347C17.095 14.2934 12.1525 8.23381 5.26356 6.73584L5.00967 7.17592C7.46397 9.55405 8.83499 12.8293 8.81806 16.2484C8.81806 26.7088 -0.000488281 34.1394 -0.000488281 46.1316C-0.000488281 57.1844 7.72632 68.4488 30.1028 68.4488C50.0418 68.4488 60.553 58.6823 60.553 48.2981C60.5361 39.378 54.1549 31.8374 41.7988 30.661Z",
    fill: "url(#paint0_linear_7_1031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3651 53.4776L36.0269 -0.000732422H24.2802L29.942 53.4776H30.3651Z",
    fill: "#0460A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_1031",
    x1: 0.0119471,
    y1: 37.627,
    x2: 51.257,
    y2: 37.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E74A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EC9A1E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovartis);
export default __webpack_public_path__ + "static/media/novartis.f0036d48033de12eb71740e0708abbe9.svg";
export { ForwardRef as ReactComponent };